import script from "./DemoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoBanner.vue?vue&type=script&setup=true&lang=js"

import "./DemoBanner.vue?vue&type=style&index=0&id=e43a9b28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e43a9b28"]])

export default __exports__